module.exports = __webpack_public_path__ + "a01dca8e950b5e34a0ca50c7bc3c96a5.pdf";